const PluggedInModules = {}

try {
    PluggedInModules['qpu'] = { path: require('@cmodules/qpu'), enabled: true } // special user Module ()
} catch (e) {
    console.error('No QPU Module', e)
}

try {
    PluggedInModules['user'] = { path: require('@devModules/user'), enabled: true } // special user Module ()
} catch (e) {
    console.error('No User Module', e)
}

// try {
//     PluggedInModules['roles_permissions'] = { path: require('@devModules/rolespermissions'), enabled: true } // special user Module ()
// } catch (e) {
//     console.error('No Role & Permissions Module', e)
// }

export default PluggedInModules
